import { render, staticRenderFns } from "./indextwo.vue?vue&type=template&id=35ac213d&scoped=true&"
import script from "./indextwo.vue?vue&type=script&lang=js&"
export * from "./indextwo.vue?vue&type=script&lang=js&"
import style0 from "./indextwo.vue?vue&type=style&index=0&id=35ac213d&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35ac213d",
  null
  
)

export default component.exports